import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import {
  Form,
  Button,
  Col,
  Dropdown,
  Modal,
  NavLink,
  Row,
} from "react-bootstrap";
import { ChevronDown } from "react-feather";
import UploadFileSharpIcon from "@mui/icons-material/UploadFileSharp";
import axios from "../../API/axios";
import defaultImage from "../../../src/assets/images/Default_user_image.png";
import DataTable from "react-data-table-component";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import SearchIcon from "@mui/icons-material/Search";
import EditIcon from "@mui/icons-material/Edit";
import Tooltip from "@mui/material/Tooltip";
import NoteAddSharpIcon from "@mui/icons-material/NoteAddSharp";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import { customStyles } from "../../selectStyles";
import ReactSelect from "react-select";
import GroupSharpIcon from "@mui/icons-material/GroupSharp";
const BulkResume = () => {
  const sessionId = localStorage.getItem("sessionId");
  const [fileName, setFileName] = useState(""); // State to store selected filename
  const fileInputRef = useRef(null); // Reference to hidden file input
  const userUID = localStorage.getItem("userUID");
  const [currentPage, setCurrentPage] = useState(0);
  const [candidateList, setCandidateList] = useState([]);
  const [search, setSearch] = useState("");
  const [display, setDisplay] = useState(false);
  const [page, setPage] = useState(0);
  const [classGroupBatch, setClassGroupBatch] = useState("All");
  const [groupBatchType, setGroupBatchType] = useState("All");
  const [groupBatchId, setGroupBatchId] = useState(0);
  const [show, setShow] = useState(false);

  const [selectedCandidateClass, setSelectedCandidateClass] = useState(null); // State for selected class in modal
  const [selectedCandidateBatch, setSelectedCandidateBatch] = useState([]); // State for selected batch in modal
  const [candidateData, setCandidateData] = useState({}); // State for selected batch in modal

  const handleShow = (candidate) => {
    console.log("Selected candidate:", candidate); // Log the candidate object

    // Set class details
    setSelectedCandidateClass({
      value: candidate.clssID,
      label: candidate.insttClssName,
    });

    // Map btchID to batch names
    const batches = Array.isArray(candidate.batchNames)
      ? candidate.batchNames
      : [];
    const batchIDs = Array.isArray(candidate.btchID)
      ? candidate.btchID
      : [candidate.btchID];
    const formattedBatches = batchIDs.map((batchID, index) => ({
      value: batchID,
      label: batches[index] || `Batch ${batchID}`,
    }));

    // Set selected batches for ReactSelect
    setSelectedCandidateBatch(formattedBatches);
    setCandidateData(candidate);
    setShow(true);
  };

  console.log("candidateList", candidateList);

  const columns = [
    {
      name: "NAME",
      // center: true,
      sortable: true,
      cell: (row) => (
        <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
          {/* Row for Image and Username */}
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            {/* User Image */}
            <img
              src={row.profileImage}
              alt="User"
              style={{ width: "40px", height: "40px", borderRadius: "50%" }}
            />

            {/* Username */}
            <div className="pointer">{row.firstName}</div>
          </div>
          <div className="pointer ms-5">{row.lastName}</div>
        </div>
      ),
    },
    {
      name: "GENDER",
      center: true,
      sortable: true,
      selector: (row) => row.genderName,
    },
    {
      name: "CLASS NAME",
      center: true,
      sortable: true,
      selector: (row) => row.insttClssName,
    },
    {
      name: "BATCH NAME",
      center: true,
      sortable: true,
      selector: (row) =>
        Array.isArray(row.batchNames)
          ? row.batchNames.join(", ")
          : row.batchNames,
    },
    {
      name: "ACTION",
      center: true,
      cell: (row) => (
        <>
          <Tooltip title="Candidate List" arrow>
            <GroupSharpIcon
              className="me-2 pointer"
              onClick={() => handleShow(row)}
            />
          </Tooltip>

          <Link to={`/UpdateCandidatebyInstitute/${row.instnCnddtID}`}>
            <Tooltip title="Edit" arrow>
              <EditIcon className="edit-icon Dark-icon-color" />
            </Tooltip>
          </Link>
          <Link
            to={`/ManageResume/${row.instnCnddtID}`}
            className="ms-2"
            state={{ cnddtId: row.instnCnddtID }}
          >
            <Tooltip title="Bookmark" arrow>
              <NoteAddSharpIcon className="edit-icon Dark-icon-color" />
            </Tooltip>
          </Link>
          <Link
            target="blank"
            to={`/Resume?userUID=${userUID}&InsttId=${row.instnCnddtID}`}
          >
            <Tooltip title="ViewResume" arrow>
              <VisibilitySharpIcon
                style={{ cursor: "pointer", color: "black" }}
                className="ms-2 joblist-eye-icon Dark-icon-color"
              />
            </Tooltip>
          </Link>
        </>
      ),
    },
  ];

  const handleTabChange = (tab) => {
    const type = tab === 1 ? "Class" : tab === 2 ? "Batch" : "All";
    setGroupBatchType(type); // Update type
    setGroupBatchId(tab); // Update ID
    setClassGroupBatch(type); // Update displayed tab
  };

  const getGetAllCandidate = (page) => {
    const data = {
      pageNumber: page,
      pageSize: 10,
    };

    axios
      .post(
        `/Candidate/GetAllByInstt/${userUID}?Type=${groupBatchType}&TypeId=${groupBatchId}&Search=${search}`,
        data
      )
      .then((response) => {
        const res = response.data.responseData.items;
        console.log("resto", res);

        setCandidateList(res);
        setDisplay(false);
      })
      .catch((e) => {
        console.error("Error fetching candidates:", e);
        if (e.response && e.response.status === 404) {
          setDisplay(true);
        }
      });
  };

  useEffect(() => {
    setPage(0); // Reset page to 0 on filter or search change
    getGetAllCandidate(page);
  }, [groupBatchType, groupBatchId, search]); // Dependency array includes filters and search

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFileName(file.name);
    }
  };

  const handleClose = () => {
    setShow(false);
    setFileName("");
  };

  const tabStyle = (isActive) => ({
    borderBottom: isActive ? "3px solid #feaa00" : "none",
    cursor: "pointer",
    width: "100px",
    height: "50px",
    lineHeight: "50px",
    textAlign: "center",
  });

  // Inside the component
  const [classList, setClassList] = useState([]); // State to store class options
  const [selectedClass, setSelectedClass] = useState(null); // State for selected class

  const GetCandidateClass = () => {
    const data = {
      sessionId: sessionId, // Ensure sessionId is properly defined or retrieved
      name: "",
      type: "Class",
    };

    axios
      .post(`/Institute/GetCandidateClasses`, data)
      .then((response) => {
        console.log("Class data", response.data.responseData);
        const res = response.data.responseData;
        const data = res.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setClassList(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    GetCandidateClass();
  }, []); 

  // Handle class selection and fetch candidates
  const handleClassChange = (selectedOption) => {
    setSelectedClass(selectedOption);
    setGroupBatchType("Class");
    setGroupBatchId(selectedOption?.value || 0);
    getGetAllCandidate(0); // Fetch candidates for the selected class
  };

  const [batchList, setBatchList] = useState([]); // State to store batch options
  const [selectedBatch, setSelectedBatch] = useState(null); // State for selected batch

  const GetCandidateBatch = () => {
    const data = {
      sessionId: sessionId, // Ensure sessionId is properly defined or retrieved
      name: "",
      type: "Batch",
    };

    axios
      .post(`/Institute/GetCandidateClasses`, data)
      .then((response) => {
        console.log("Batch data", response.data.responseData);
        const res = response.data.responseData;
        const data = res.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setBatchList(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    GetCandidateClass(); // Fetch class data on component mount
    GetCandidateBatch(); // Fetch batch data on component mount
  }, []);

  // const AddClass = () => {
  //   // Check if class and batch have changed; if not, retain the previous values
  //   const classId = selectedCandidateClass ? selectedCandidateClass.value : candidateData.insttClssId; // Assuming insttClssId is the previous class ID
  //   const batchIds = selectedCandidateBatch.length > 0 ? selectedCandidateBatch.map(batch => batch.value) : candidateData.batchIds; // Assuming batchIds is an array of previous batch IDs
  //   const batchIDsForAPI = selectedCandidateBatch.map(batch => batch.value);
  //   const data = {
  //     sessionId: sessionId,
  //     insttCnddtId: candidateData.instnCnddtID,
  //     clssID: classId,
  //     btchID: batchIDsForAPI // This can be a single value or an array, depending on your backend API expectations
  //   };
  //   console.log('jshddj', data);

  //   axios
  //     .post(`/Candidate/UpdateInsttCnddtGroup`, data) // Use the correct endpoint for adding/updating the candidate
  //     .then((response) => {
  //       console.log("Update response", response.data.responseData);
  //       // Optionally, you may want to fetch updated candidate data or close the modal here
  //       handleClose(); // Close the modal after successful update
  //       getGetAllCandidate(0); // Refresh the candidates list after updating
  //     })
  //     .catch((error) => {
  //       console.log("Error updating candidate:", error);
  //     });
  // };
  const AddClass = () => {
    // Check if class and batch have changed; if not, retain the previous values
    const classId = selectedCandidateClass
      ? selectedCandidateClass.value
      : candidateData.insttClssId; // Assuming insttClssId is the previous class ID

    // Convert batch IDs to a comma-separated string
    const batchIDsForAPI =
      selectedCandidateBatch.length > 0
        ? selectedCandidateBatch.map((batch) => batch.value).join(",")
        : candidateData.btchID; // Use existing btchID if no changes made

    const data = {
      sessionId: sessionId,
      insttCnddtId: candidateData.instnCnddtID,
      clssID: classId,
      btchID: batchIDsForAPI, // Send as a comma-separated string
    };

    console.log("Payload:", data);

    axios
      .post(`/Candidate/UpdateInsttCnddtGroup`, data) // Use the correct endpoint for adding/updating the candidate
      .then((response) => {
        console.log("Update response", response.data.responseData);
        // Optionally, you may want to fetch updated candidate data or close the modal here
        handleClose(); // Close the modal after successful update
        getGetAllCandidate(0); // Refresh the candidates list after updating
      })
      .catch((error) => {
        console.log("Error updating candidate:", error);
      });
  };

  console.log("selectedCandidateBatch", selectedCandidateBatch);

  return (
    <>
      <section className="pricing-section-three container jobapplication bulkResume view-job-style pt-5">
        <div className="mt-2">
          <h4 className="orange-title">
            <span className="orange-box me-2"></span>
            Institute Candidates{" "}
          </h4>
        </div>
        <div className="container st3">
          <div className="tabButton d-flex w-100 ps-0 connectionTab mt-1">
            <NavLink
              onClick={() => handleTabChange(0)}
              style={tabStyle(classGroupBatch === "All")}
            >
              <p className="f-14 m-0 tabName">ALL</p>
            </NavLink>
            <NavLink
              onClick={() => handleTabChange(1)}
              style={tabStyle(classGroupBatch === "Class")}
            >
              <p className="f-14 m-0 tabName">Class</p>
            </NavLink>
            <NavLink
              onClick={() => handleTabChange(2)}
              style={tabStyle(classGroupBatch === "Batch")}
            >
              <p className="f-14 m-0 tabName">Batch</p>
            </NavLink>
          </div>

          <div className="tabContent">
            <div className="manage-search-container">
              <div className="manage-search-bar">
                <SearchIcon className="icon" />
                <input
                  type="text"
                  placeholder="Search..."
                  className="manage-search-input"
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>

              {classGroupBatch === "Class" && (

                <div className="dropdown-container">
                  <ReactSelect
                    options={classList}
                    onChange={handleClassChange}
                    value={selectedClass}
                    placeholder="Select Class"
                    styles={customStyles}
                    classNamePrefix="react-select"
                    className="form-control  Dark-Input-from-group"
                  />
                </div>
              )}
              {classGroupBatch === "Batch" && (
                <div className="dropdown-container">
                  <ReactSelect
                    options={batchList}
                    onChange={(selectedOption) => {
                      setSelectedBatch(selectedOption);
                      setGroupBatchType("Batch");
                      setGroupBatchId(selectedOption?.value || 0);
                      getGetAllCandidate(0); // Fetch candidates for the selected batch
                    }}
                    value={selectedBatch}
                    placeholder="Select Batch"
                    styles={customStyles}
                    classNamePrefix="react-select"
                    className="form-control  Dark-Input-from-group"
                  />
                </div>
              )}
            </div>
          </div>

          <div className="manage-batches-container">
            <h2 className="manage-heading">{classGroupBatch} List</h2>
          </div>

          {display ? (
            <p className="text-center">No data found</p>
          ) : (
            <div className="scroll-react-dataTable">

              <div className="react-dataTable">
                <DataTable
                  noHeader
                  pagination
                  columns={columns}
                  paginationPerPage={7}
                  className="react-dataTable"
                  sortIcon={<ChevronDown size={10} />}
                  paginationDefaultPage={currentPage + 1}
                  data={candidateList}
                />
              </div>
            </div>
          )}
        </div>
      </section>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header>
          <Modal.Title>Update Candidate Group</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={handleClose} />
        </Modal.Header>
        <Modal.Body className="settings">
          <Row>
            <Col md={12}>
              <Form.Group controlId="Name_Title">
                <Form.Label className="class-type">Class</Form.Label>
              </Form.Group>
              <div className="post-form-group">
                <ReactSelect
                  placeholder="Select Class"
                  classNamePrefix="react-select"
                  className="form-control"
                  styles={customStyles}
                  options={classList}
                  value={
                    classList.find(
                      (option) => option.value === selectedCandidateClass?.value
                    ) || null
                  } // Set the value based on the selected class
                  onChange={(selectedOption) => {
                    setSelectedCandidateClass(selectedOption); // Update selected class
                  }} // Handle class selection
                />
              </div>
            </Col>
            <Col md={12}>
              <Form.Group controlId="Name_Title">
                <Form.Label className="class-type">Batch</Form.Label>
              </Form.Group>

              {/* <div className="post-form-group">
                <ReactSelect
                  placeholder="Select Batch"
                  classNamePrefix="react-select"
                  className="form-control"
                  styles={customStyles}
                  isMulti
                  options={batchList} // Ensure batchList is in the format [{ value: 'batch1', label: 'Batch 1' }, ...]
                  value={selectedCandidateBatch} // Use the selectedCandidateBatch directly
                  onChange={(selectedOptions) => {
                    setSelectedCandidateBatch(selectedOptions || []); // Ensure selectedOptions is an array, fallback to empty
                  }} // Handle batch selection
                />
              </div> */}
              <div className="post-form-group">
                <ReactSelect
                  placeholder="Select Batch"
                  classNamePrefix="react-select"
                  className="form-control"
                  styles={customStyles}
                  isMulti
                  options={batchList} // List of all available batches
                  value={selectedCandidateBatch} // Selected batches (ID and name)
                  onChange={(selectedOptions) => {
                    const selectedIDs = selectedOptions.map(
                      (option) => option.value
                    ); // Extract IDs for API
                    setSelectedCandidateBatch(selectedOptions); // Update for display
                    console.log("Selected Batch IDs for API:", selectedIDs); // Log IDs
                  }}
                />
              </div>
            </Col>
          </Row>
          <div className=" mt-4 d-flex justify-content-center">
            <Button onClick={AddClass}>Update</Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default BulkResume;
